import React from 'react'
import { useState } from 'react';
import { useAlert } from "react-alert";


function Form2() {
    const alert = useAlert();


    const [firstname, setfirstname] = useState();
    const [lastname, setlastname] = useState();
    const [address, setaddress] = useState();
    const [postcode, setpostcode] = useState();
    const [dateofbirth, setdateofbirth] = useState();
    const [ninumber, setninumber] = useState();
    const [utrnumber, setutrnumber] = useState();
    const [taxyear, settaxyear] = useState();
    const [natureofbusiness, setnatureofbusiness] = useState();
    const [turnover, setturnover] = useState();
    const [tips, settips] = useState();
    const [otherbusinessincome, setotherbusinessincome] = useState();
    const [fuel, setfuel] = useState();
    const [insurance, setinsurance] = useState();
    const [radiorent, setradiorent] = useState();
    const [licensingfee, setlicensingfee] = useState();
    const [mobilecommunication, setmobilecommunication] = useState();
    const [repair, setrepair] = useState();
    const [accountingcost, setaccountingcost] = useState();
    const [bankcharges, setbankcharges] = useState();
    const [otherexpense, setotherexpense] = useState();
    const [car, setcar] = useState();
    const [carmileage, setcarmileage] = useState();
    const [capitalpersonaluse, setcapitalpersonaluse] = useState();
    const [personaluse, setpersonaluse] = useState();
    const [ otherincomeincludeproperty, setotherincomeincludeproperty] = useState();
    const [valueofcar, setvalueofcar] = useState();
    const [caremission, setcaremission] = useState();
    const [loading, setloading] = useState(false);

    const formSubmitHandler = async (e) => {
        setloading(true)
        e.preventDefault();

        const res = await fetch('https://ajh-accountant.onrender.com/api/client-forms', {

            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data:{
                    firstname, lastname, address, postcode, dateofbirth, ninumber, utrnumber, taxyear, natureofbusiness, 
                    turnover, tips, otherbusinessincome, fuel, insurance, radiorent, licensingfee, mobilecommunication, repair, accountingcost, 
                    bankcharges, otherexpense, car, carmileage, capitalpersonaluse, personaluse, otherincomeincludeproperty, valueofcar
                    , caremission
            }
            })
        }).then((response)=>{
            response.json()
setloading(false)
            alert.success("Form Submitted Successfully");

        }).catch((error)=>{
            setloading(true)
            alert.success(error);
        })

        // const data = await res.json()


         setfirstname('');
        setlastname('');
        setaddress('');
        setpostcode('');
        setdateofbirth('');
        setninumber('');
        setutrnumber('');
        settaxyear('');
        setnatureofbusiness('');
        setturnover('');
        settips('');
        setotherbusinessincome('');
        setfuel('');
        setinsurance('');
        setradiorent('');
        setlicensingfee('');
        setmobilecommunication('');
        setrepair('');
        setaccountingcost('');
        setbankcharges('');
        setotherexpense('');
        // setcar('');
        setcarmileage('');
        // setcapitalpersonaluse('');
        setpersonaluse('');
        setotherincomeincludeproperty('');
        setvalueofcar('');
        setcaremission('');

    }
  
    const [employment, setemploymet] = useState();


  return (
    <div>
          <div className="container-fluid main-contact-div1 contacts-div1">
              <svg
                  className="contact-vector1 d-sm-block d-none"
                  width="65"
                  height="201"
                  viewBox="0 0 65 201"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                  <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M103.476 0.0623773C144.217 1.51047 171.061 37.8544 183.39 76.877C195.394 114.872 192.755 158.559 161.184 182.719C127.602 208.417 81.0343 206.104 46.6254 181.535C11.0388 156.125 -9.07933 112.331 4.02486 70.5016C17.4843 27.5381 58.656 -1.53073 103.476 0.0623773Z"
                      fill="#FFB532"
                  />
              </svg>

              <div className="container main-contact-div2">
                  <h1 className=" contactus-text1 ">
                      Get In Touch With <span>US</span>.
                  </h1>
                  <div className="contactus-btn-div">
                      <a href="tel:+44 01204 840303">
                          <div className="contact-btn1">
                              <p className="contactus-text2 text-center">+44 01204 840303</p>
                          </div>
                      </a>
                      <a href="mailto:info@ajhaccountant.co.uk">
                          <div className="contact-btn2">
                              <p className="contactus-text2">info@ajhaccountant.co.uk</p>
                          </div>
                      </a>
                  </div>

                  <div>
                      <form className="contact-form" onSubmit={formSubmitHandler}>
                          <div class="row">
                            <div className='col-12'>
                                <h1 className='forms-heading11'> Personal Information</h1>
                            </div>
                              <div class="col-lg-6 col-12 ">
                                  <label className='form-labels'>First Name</label>
                                  <input
                                      type="text"
                                      name="firstname"
                                      class="form-control contact-input-field5"
                                      placeholder="First Name"
                                      onChange={(e) => setfirstname(e.target.value)}
                                      value={firstname}
                                  />
                              </div>
                              <div class="col-lg-6 col-12 mt-4 mt-lg-0">
                                  <label className='form-labels'>Last Name</label>
                                  <input
                                      type="text"
                                      name="lastname"
                                      onChange={(e) => setlastname(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="Last Name"
                                      value={lastname}
                                  />
                              </div>
                              <div class="col-lg-12 col-12 mt-4">
                                  <label className='form-labels'>Address</label>
                                  <input
                                      type="text"
                                      name="address"
                                      onChange={(e) => setaddress(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder='Address'
                                      value={address}
                                  />
                              </div>
                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Postcode</label>

                                  <input
                                      type="number"
                                      name="postcode"
                                      onChange={(e) => setpostcode(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="Postcode"
                                      value={postcode}
                                  />
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Date of Birth</label>
                                  <input
                                      type="date"
                                      name="dateofbirth"
                                      onChange={(e) => setdateofbirth(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder='Date of Birth'
                                      value={dateofbirth}
                                  />
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>NI Number</label>

                                  <input
                                      type="number"
                                      name="ninumber"
                                      onChange={(e) => setninumber(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="NI Number"
                                      value={ninumber}
                                  />
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>UTR Number</label>

                                  <input
                                      type="number"
                                      name="utrnumber"
                                      onChange={(e) => setutrnumber(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="UTR Number"
                                      value={utrnumber}
                                  />
                              </div>

                              <div className='col-12'>
                                <h1 className='forms-heading12'> Tax Year</h1>
                            </div>

                              <div class="col-lg-12 col-12 mt-4">
                                  <label className='form-labels'>Tax Year</label>

                                  <input
                                      type='text'
                                      name="taxyear"
                                      class="form-control contact-input-field5"
                                      placeholder="Tax Year"
                                      onChange={(e) => settaxyear(e.target.value)}
                                      value={taxyear}
                                  />
                              </div>

                              <div className='col-12'>
                                  <h1 className='forms-heading12'> Self Employment Detail</h1>
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Nature of Business</label>

                                  <input
                                      type='text'
                                      name="natureofbusiness"
                                      onChange={(e) => setnatureofbusiness(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="Nature of Bussiness"
                                      value={natureofbusiness}
                                  />
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Turn Over</label>

                                  <input
                                      type='text'
                                      name="turnover"
                                      onChange={(e) => setturnover(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="Turn Over"
                                      value={turnover}
                                  />
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Tips</label>

                                  <input
                                      type='text'
                                      name="tips"
                                      onChange={(e) => settips(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="Tips"
                                      value={tips}
                                  />
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Any Other Income</label>

                                  <input
                                      type='text'
                                      onChange={(e) => setotherbusinessincome(e.target.value)}
                                      name="otherbusinessincome"
                                      class="form-control contact-input-field5"
                                      placeholder="Any Other Income related to Business"
                                      value={otherbusinessincome}
                                  />
                              </div>

                              <div className='col-12'>
                                  <h1 className='forms-heading12'>Expense</h1>
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Fuel</label>

                                  <input
                                      type='text'
                                      name="fuel"
                                      class="form-control contact-input-field5"
                                      placeholder="Fuel"
                                      onChange={(e) => setfuel(e.target.value)}
                                      value={fuel}
                                  />
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Insurance</label>

                                  <input
                                      type='text'
                                      name="insurance"
                                      onChange={(e) => setinsurance(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="Insurance"
                                      value={insurance}
                                  />
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Radio Rent</label>

                                  <input
                                      type='text'
                                      name="radiorent"
                                      onChange={(e) => setradiorent(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="Radio Rent"
                                      value={radiorent}
                                  />
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Licensing Fee</label>

                                  <input
                                      type='text'
                                      name="licensingfee"
                                      onChange={(e) => setlicensingfee(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="Licensing Fee"
                                      value={licensingfee}
                                  />
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Mobile & other Communication</label>

                                  <input
                                      type='text'
                                      name="mobilecommunication"
                                      onChange={(e) => setmobilecommunication(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="Mobile & other Communication Expenses"
                                      value={mobilecommunication}
                                  />
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Repair</label>

                                  <input
                                      type='text'
                                      name="repair"
                                      onChange={(e) => setrepair(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="Repir Expenses"
                                      value={repair}
                                  />
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Accounting Cost</label>

                                  <input
                                      type='text'
                                      name="accountingcost"
                                      onChange={(e) => setaccountingcost(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="Accounting Cost Expenses"
                                      value={accountingcost}
                                  />
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Bank Charges</label>

                                  <input
                                      type='text'
                                      name="bankcharges"
                                      onChange={(e) => setbankcharges(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="Bank Charges"
                                      value={bankcharges}
                                  />
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Other</label>

                                  <input
                                      type='text'
                                      name="otherexpense"
                                      onChange={(e) => setotherexpense(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="Other Expenses"
                                      value={otherexpense}
                                  />
                              </div>

                              <div className='col-12'>
                                  <h1 className='forms-heading12'>Vehicle Information</h1>
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Do you own car?</label>
                                  <div className='row' style={{'paddingLeft':'15px'}}>

                                      <div className='col-6 d-flex align-items-center'>
                                          <input
                                              type='radio'
                                              name="car"
                                              class="form-check-input contact-input-field5"
                                              placeholder="Yes"
                                              value='Yes'
                                              onChange={(e) => { setcar(e.target.value) }}
                                          />
                                          <label className='form-check-label radio-form-labels'>Yes</label>
                                      </div>
                                      <div className='col-6 d-flex align-items-center'>
                                          <input
                                              type='radio'
                                              name="car"
                                              class="form-check-input contact-input-field5"
                                              placeholder="Yes"
                                              value='No'
                                              onChange={(e) => { setcar(e.target.value) }}
                                          />
                                          <label className='form-check-label radio-form-labels'>No</label>
                                      </div>
                                    
                                  </div>

                              </div>

                              <div className={`${car == "Yes"
                                  ? "col-lg-6 col-12 mt-4 d-block"
                                  : "d-none"
                                  }`}>
                                  <label className='form-labels'>Mileage</label>

                                  <input
                                      type='text'
                                      name="carmilage"
                                      onChange={(e) => setcarmileage(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="Mileage during the year"
                                      value={carmileage}
                                      
                                  />
                              </div>


                              <div className='col-12'>
                                  <h1 className='forms-heading12'>Capital Allowance</h1>
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Personal Use?</label>
                                  <div className='row' style={{ 'paddingLeft': '15px' }}>

                                      <div className='col-6 d-flex align-items-center'>
                                          <input
                                              type='radio'
                                              name='capitalpersonaluse'
                                              class="form-check-input contact-input-field5"
                                              placeholder="Yes"
                                              value='Yes'
                                              onChange={(e) => { setcapitalpersonaluse(e.target.value) }}
                                          />
                                          <label className='form-check-label radio-form-labels'>Yes</label>
                                      </div>
                                      <div className='col-6 d-flex align-items-center'>
                                          <input
                                              type='radio'
                                              class="form-check-input contact-input-field5"
                                              placeholder="Yes"
                                              name='capitalpersonaluse'
                                              value='No'
                                              onChange={(e) => { setcapitalpersonaluse(e.target.value) }}
                                          />
                                          <label className='form-check-label radio-form-labels'>No</label>
                                      </div>

                                  </div>

                              </div>

                              <div className={`${capitalpersonaluse == "Yes"
                                  ? "col-lg-6 col-12 mt-4 d-block"
                                  : "d-none"
                                  }`}>
                                  <label className='form-labels'>Personal Use</label>

                                  <input
                                      type='text'
                                      name="personaluse"
                                      onChange={(e) => setpersonaluse(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="Percentage of Personal Use"
                                      value={personaluse}

                                  />
                              </div>

                              <div className='col-12'>
                                  <h1 className='forms-heading12'>Other Income</h1>
                              </div>

                              <div class="col-lg-12 col-12 mt-4">
                                  <label className='form-labels'>Other Income Including Property Income</label>

                                  <input
                                      type='text'
                                      name="otherincomeincludeproperty"
                                      onChange={(e) => setotherincomeincludeproperty(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="Specify any Other Income Including Property Income"
                                      value={otherincomeincludeproperty}
                                  />
                              </div>


                              <div className='col-12'>
                                  <h1 className='forms-heading12'>Car Details</h1>
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Value of Car</label>

                                  <input
                                      type='text'
                                      name="valueofcar"
                                      onChange={(e) => setvalueofcar(e.target.value)}
                                      class="form-control contact-input-field5"
                                      value={valueofcar}
                                      placeholder="Value of Car at the start of the financial Year"
                                  />
                              </div>

                              <div class="col-lg-6 col-12 mt-4">
                                  <label className='form-labels'>Car Emission</label>

                                  <input
                                      type='text'
                                      name="caremission"
                                      onChange={(e) => setcaremission(e.target.value)}
                                      class="form-control contact-input-field5"
                                      placeholder="Car Emission for capital allowance purpose"
                                      value={caremission}
                                  />
                              </div>

                              <div className="col-12 mt-4 contact-us-btn-div2">
                                  <button
                                      type="submit"
                                      className="ml-sm-auto mx-sm-0 mx-auto contactus-form-btn4 mb-4"
                                  >
                                      {loading ? "Please Wait..." : 'Submit'}
                                  </button>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
    </div>
  )
}

export default Form2
